import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";
import { selectCls, Pill } from "./shared";
import { fmtDateTime } from "@/lib/money";

const LABELS = {
  "plan.create": "Criou plano", "plan.update": "Editou plano", "plan.price_change": "Alterou preço", "plan.activate": "Ativou plano", "plan.deactivate": "Desativou plano", "plan.duplicate": "Duplicou plano",
  "promotion.create": "Criou promoção", "promotion.update": "Editou promoção", "promotion.activate": "Ativou promoção", "promotion.deactivate": "Desativou promoção", "promotion.end": "Encerrou promoção", "promotion.duplicate": "Duplicou promoção",
  "payment.approve": "Confirmou pagamento", "payment.reject": "Recusou pagamento", "subscription.cancel": "Cancelou assinatura", "subscription.suspend": "Suspendeu assinatura", "subscription.reactivate": "Reativou assinatura", "subscription.manual_activate": "Liberou plano manualmente",
};
const TONE = (a) => (a.includes("price") ? "amber" : a.includes("cancel") || a.includes("reject") || a.includes("deactivate") || a.includes("end") || a.includes("suspend") ? "red" : "cyan");

export function AuditLog() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("");
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/admin/audit", { params: { resource_type: type } }).then(({ data }) => setItems(data)).catch(() => toast.error("Erro ao carregar auditoria.")); }, [type]);

  return (
    <div className="space-y-3" data-testid="audit-log">
      <div className="flex items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-sm text-slate-400"><ScrollText className="h-4 w-4" /> {items.length} registro(s) · nunca apagados</p>
        <select className={`${selectCls} w-auto`} value={type} onChange={(e) => setType(e.target.value)} data-testid="audit-filter"><option value="">Tudo</option><option value="plan">Planos</option><option value="promotion">Promoções</option><option value="payment">Pagamentos</option><option value="company">Assinaturas</option></select>
      </div>
      <div className="glow-card overflow-hidden rounded-2xl">
        {items.length === 0 && <p className="p-8 text-center text-sm text-slate-500">Nenhuma ação administrativa registrada.</p>}
        {items.map((a) => (
          <div key={a.id} className="border-b border-slate-800/50 px-5 py-3" data-testid="audit-row">
            <button type="button" onClick={() => setOpen(open === a.id ? null : a.id)} className="flex w-full flex-wrap items-center justify-between gap-2 text-left">
              <div>
                <p className="text-sm text-slate-100"><Pill tone={TONE(a.action)}>{LABELS[a.action] || a.action}</Pill> <span className="ml-2 font-mono-flow text-xs text-slate-400">{a.resource_id}</span></p>
                <p className="mt-1 text-xs text-slate-500">{a.email} · {fmtDateTime(a.at)}{a.ip ? ` · ${a.ip}` : ""}{a.reason ? ` · motivo: ${a.reason}` : ""}</p>
              </div>
              <span className="text-xs text-cyan-300">{open === a.id ? "ocultar" : "ver dados"}</span>
            </button>
            {open === a.id && (
              <div className="mt-2 grid gap-2 sm:grid-cols-2" data-testid="audit-detail">
                <pre className="max-h-48 overflow-auto rounded-lg border border-slate-800 bg-slate-950 p-2 text-[11px] text-slate-400"><span className="text-slate-500">ANTES</span>{"\n"}{JSON.stringify(a.before, null, 1)}</pre>
                <pre className="max-h-48 overflow-auto rounded-lg border border-slate-800 bg-slate-950 p-2 text-[11px] text-slate-300"><span className="text-slate-500">DEPOIS</span>{"\n"}{JSON.stringify(a.after, null, 1)}</pre>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
